import Cookies from 'universal-cookie';
import TagManager from 'react-gtm-module';
import base64decode from 'base-64';

//controllers
import Qualidade_controller, { getGrupos, getFamilias } from '../../../../../../../controllers/qualidade';
import Config from '../../../../../../../controllers/config';
import { filterValidation } from './filterValidation';

export default (props) => {

    const loadMoveis = async (linhaInicial, qtdRegistro) => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            // Dados do DropDown de Grupos
            const opcoesGrupos = await loadGrupos();
            props.setState({ opcoesGrupos });
            
            let alfaNumerico = null;
            let nomeProduto = null;
            let fornecedor = null;
            let linha = null;
            let idProduto = null;
            let grupo = null;
            let familia = null;
            let pStatus = null;

            const arrayColAlfaNumerico = props.state.colunasFilterTagsMoveis
            .filter(element => (
                element.key === "Alfa numérico" &&
                element.value !== element.origemValue
            ));

            const arrayColNomeProduto = props.state.colunasFilterTagsMoveis
            .filter(element => (
                element.key === "Nome do produto" &&
                element.value !== element.origemValue
            ));

            const arrayColLinha = props.state.colunasFilterTagsMoveis
            .filter(element => (
                element.key === "Linha" &&
                element.value !== element.origemValue
            ));

            const arrayColIdProduto = props.state.colunasFilterTagsMoveis
            .filter(element => (
                element.key === "ID do Produto" &&
                element.value !== element.origemValue
            ));

            if (arrayColAlfaNumerico.length > 0) {
                alfaNumerico = arrayColAlfaNumerico[0].value;
            }

            if (arrayColNomeProduto.length > 0) {
                nomeProduto = arrayColNomeProduto[0].value;
            }
            
            if (arrayColLinha.length > 0) {
                linha = arrayColLinha[0].value;
            }
            
            if (arrayColIdProduto.length > 0) {
                idProduto = arrayColIdProduto[0].value;
            }

            const { escolhaGrupo, escolhaFamilia } = props.state;
            if (escolhaGrupo !== 0) {
                const { cd_grupo } = props.state.opcoesGrupos[escolhaGrupo];
                grupo = cd_grupo;
            }
            
            familia = escolhaFamilia === 0 ? null : escolhaFamilia;
            fornecedor = props.state.fornecedor;
            
            if (fornecedor == null) {
                fornecedor = 0;
            }

            if (props.state.statusMoveis == "Aprovado") {
                pStatus = "A";
            } else if (props.state.statusMoveis == "Pendente") {
                pStatus = "P";
            /*Caso seja inserido futuramente*/
            } else if (props.state.statusMoveis == "Reprovado") {
                pStatus = "R";
            } else {
                pStatus = "";
            }

            if (!props.isVisaoTok) {
                pStatus = "A";
            }
            
            const query = {
                LinhaInicial: linhaInicial,
                QtdRegistro: qtdRegistro,
                DsStatus: pStatus,
                idSituacao: props.state.escolhaSituacaoMoveis,
                Departamento: "P",
                // P de Planejados
                inAcessMoveis: "P",
                
                alfaNumerico: alfaNumerico || props.state.searchFieldExternalMoveis,
                nomeProduto,
                fornecedor,
                linha,
                idProduto,
                grupo,
                familia,
            };
            const o_qualidade = await Qualidade_controller.get(token,query);
            const j_o_qualidade = JSON.parse(o_qualidade.body);
            
            if (o_qualidade.res.statusCode === 200) {
                
                const validaItensMoveis = j_o_qualidade.length > 0
                props.setState({
                    dataMoveis: validaItensMoveis ? j_o_qualidade : [],
                    totalRowsMoveis: validaItensMoveis ? j_o_qualidade[0].qt_total_regs : 0
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:qualidade',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-moveis',
                //     }
                // });
                
            } else {
                if (
                    o_qualidade.res.statusCode === 200 && 
                    j_o_qualidade.message && 
                    j_o_qualidade.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            props.childAlert.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //     event: 'event',
            //     eventCategory: 'tokstok:fornecedores:qualidade',
            //     eventAction: 'callback',
            //     eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    };


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const sendFile = async (params,file) => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        const formData = new FormData();
        const base64 = await toBase64(file);
        formData.append("Alfanumerico", params.alfaNumerico);
        formData.append("FileName", file.name);
        formData.append("ContentFile", file.type);
        formData.append("Doc", base64.split(",")[1]);
        formData.append("Departamento", "P");
        formData.append("idUserFornecedor", params.id_fornecedor);
        formData.append("InStatus", 'A');
        formData.append("idDescr", params.idDescr);

        TagManager.dataLayer({
            dataLayer: {
                event: 'event',
                eventCategory: 'tokstok:fornecedores:qualidade',
                eventAction: 'clique:botao',
                eventLabel: `enviar-ficha-${params.alfaNumerico}`,
            }
        });
        
        let o_qualidade = null;
        if (params.ficha == null) {
            o_qualidade = await Qualidade_controller.postFileMoveis(token,formData);
        } else {
            o_qualidade = await Qualidade_controller.putFileMoveis(token,formData,params.ficha);
        }

        if (o_qualidade.status == 200) {
            // const j_o_qualidade = JSON.parse(o_qualidade.body);
            await props.setState({openModalUpFichaTecnica: true});

            // TagManager.dataLayer({
            //     dataLayer: {
            //         event: 'event',
            //         eventCategory: 'tokstok:fornecedores:qualidade',
            //         eventAction: 'callback',
            //         eventLabel: `sucesso`,
            //     }
            // });
        } else {
            // TagManager.dataLayer({
            //     dataLayer: {
            //     event: 'event',
            //     eventCategory: 'tokstok:fornecedores:qualidade',
            //     eventAction: 'callback',
            //     eventLabel: `erro:falha-upload-file-ficha-tecnica-acessorios`,
            //     }
            // });
        }

        await props.setState({lastCardSelected: null});
        props.childUploadMoveis.value = "";

        await props.setState({isLoading: true});
        await props.loadMoveis(props.state.pageFrom, props.state.rowsPerPageMoveis);
        await props.setState({isLoading: false});

        return;
    };

    const handlerLoadSearchFilterTagMoveis = () => {
        let newColunasFilterTags = props.state.colunasFilterTagsMoveis;
        for (let i = 0; i < props.state.colunasMoveis.length; i++) {
            newColunasFilterTags.push({
                key: props.state.colunasMoveis[i].key,
                value: props.state.searchFieldMoveis,
                origemValue: ""
            });
        }
        props.setState({colunasFilterTagsMoveis: newColunasFilterTags});
    };

    const handlerSelectCheckboxMoveis = (params) => {
        let newArray = props.state.dataMoveisSelected;
        const index = newArray.indexOf(params);
        if (index > -1) {
            newArray.splice(index, 1);
        } else {
            newArray.push(params);
        }
        props.setState({dataMoveisSelected: newArray});
    };

    const handlerClickCheckboxMoveis = (i) => {
        const { isFilterTypeValid } = filterValidation({
            setSnackbarMessage: props.setMessageSnackbarFilterValidation,
            toggleSnackbar: props.toggleSnackbarFilterValidation,
        });

        const filterKey = props.state.colunasMoveis[i].key;
        const filterValue = props.state.searchFieldMoveis;
        
        if(isFilterTypeValid(filterKey, filterValue)) {
            let colunms = props.state.colunasMoveis;
            colunms[i].value = !(props.state.colunasMoveis[i].value);
            props.setState({colunasMoveis: colunms});
        
            props.handlerChangeSearchFilterTagMoveis(i);
        }
    };

    const handlerClearCheckboxMoveis = () => {
        let colunms = props.state.colunasMoveis;
        props.state.colunasMoveis.forEach(element => {
            element.value = false;
        });
        props.setState({colunasMoveis: colunms});
    };

    const handlerChangeSearchFilterTagMoveis = (i) => {
        let newColunasFilterTags = props.state.colunasFilterTagsMoveis;

        const nameObject = props.state.colunasMoveis[i].key;
        const indexObject = props.state.colunasFilterTagsMoveis.map(e=>e.key).indexOf(nameObject);

        if (indexObject < 0) return;
        
        if (props.state.colunasMoveis[i].value) {
            newColunasFilterTags[indexObject].value = props.state.searchFieldMoveis;
        } else {
            newColunasFilterTags[indexObject].value = "";
        }
        
        props.setState({colunasFilterTagsMoveis: newColunasFilterTags});
    };

    const handlerClearFilterTagMoveis = (i) => {
        let newColunasFilterTags = props.state.colunasFilterTagsMoveis;
        if (newColunasFilterTags[i] == null) return;
        newColunasFilterTags[i].value = newColunasFilterTags[i].origemValue;
        props.setState({colunasFilterTagsMoveis: newColunasFilterTags});

        const index = props.state.colunasMoveis.map((e)=>{return e.key}).indexOf(newColunasFilterTags[i].key);
        if (index < 0) return;
        let colunms = props.state.colunasMoveis;
        colunms[index].value = false;
        props.setState({colunasMoveis: colunms});
    };

    const handlerChangeStatusMoveis = async (event) => {
        await props.setState({statusMoveis: event.target.value});
        
        await props.setState({
            isLoading: true,
            firstLoad: true
        });
        await props.loadMoveis(0, props.state.rowsPerPageMoveis);
        await props.setState({
            isLoading: false,
            firstLoad: false
        });
    };
    
    const handlerChangeSituacoesMoveis = (event) => {
        props.setState({escolhaSituacaoMoveis: event.target.value});
    };

    const handlerCleanFiltersMoveis = () => {
        props.state.colunasFilterTagsMoveis.forEach((element,i) => {
            props.handlerClearFilterTagMoveis(i);
        });
        props.setState({
            searchFieldMoveis: "",
            escolhaGrupo: 0,
            escolhaFamilia: 0,
            escolhaSituacaoMoveis: 0,
            isSelectFamiliasMoveisDisabled: true,
        });
    };

    const handlerAplicarFiltersMoveis = async () => {
        await props.setState({isLoading: true});
        await props.loadMoveis(0, props.state.rowsPerPageMoveis);
        await props.setState({isLoading: false});
    };

    const handlerCheckboxAllMoveis = async (event) => {
        if (props.state.dataMoveisSelected.length == props.state.totalRowsMoveis) {
            await props.setState({dataMoveisSelected: []});
        } else {
            await props.loadMoveis(0,props.state.totalRowsMoveis);
            await props.setState({dataMoveisSelected: props.state.dataMoveis});
            await props.loadMoveis(props.state.pageInitialMoveis,props.state.pageRowsMoveis);
            await props.setState({isLoading:false});
        }
    };
    
    const handlerChangeSearchFieldMoveis = (event) => {
        event.persist();
        props.setState({searchFieldMoveis: event.target.value});
    };
    
    const handlerChangeSearchFieldExternalMoveis = (event) => {
        event.persist();
        props.setState({searchFieldExternalMoveis: event.target.value});
    };

    const handlerClickSearchFieldExternalMoveis = async () => {
        await props.setState({isLoading: true});
        await props.loadMoveis(0, props.state.rowsPerPageMoveis);
        await props.setState({isLoading: false});
    };

    const onChangePageMoveis = async (pageFrom) => {
        await props.setState({isLoading: true});
        await props.loadMoveis(pageFrom, props.state.rowsPerPageMoveis);
        await props.setState({pageFrom});
        await props.setState({isLoading: false});
    };

    const onChangeFileMoveis = async (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (!event.cancelable) {
            const file = event.target.files[0];
            const sizeInMB = (file.size / (1024*1024)).toFixed(2);
            if (file.type === "") {
                props.childAlert.current.retorno('É necessário especificar uma extensão ao arquivo!','warning');
                return;
            }
            if (file.type !== "application/pdf") {
                props.childAlert.current.retorno('Extensão precisa ser pdf!','warning');
                return;
            }
            if (sizeInMB > 7) {
                props.childAlert.current.retorno('Tamanho do arquivo precisa ser inferior a 7mb!','warning');
                return;
            }

            await props.setState({isLoading: true});
            try {
              await sendFile(props.state.lastCardSelected,file);
            } catch (error) {
              console.error(error);
            }
            await props.setState({isLoading: false});
            await props.setState({lastCardSelected: null});
        }
    };

    const onClickViewModalMoveis = async (atributos) => {
        props.childUploadMoveis.click();
        props.setState({lastCardSelected: atributos});
    };

    const loadGrupos = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        const params = { inAcessMoveis: "P" }

        const response = await getGrupos({ token, params }).then((response) => JSON.parse(response.body));

        const grupos = addDefaultSelectOptionGrupos(response);
        return grupos;
    };
    
    const addDefaultSelectOptionGrupos = (grupos) => {
        grupos.unshift({
            cd_grupo: 0,
            nm_grupo: "Selecione um grupo",
            cd_div: 0,
        });
        return grupos.sort((a, b) => (a.cd_grupo > b.cd_grupo) ? 1 : -1);
    };

    const handleChangeGruposMoveis = async (event) => {
        const escolhaGrupo = event.target.value;
        props.setState({ escolhaGrupo });
        try {
          await loadFamilias({ escolhaGrupo });
        } catch (error) {
          console.error(error);
        }
    };

    const loadFamilias = async ({ escolhaGrupo }) => {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");
        const params = getParamsLoadFamilias({ escolhaGrupo });
        
        await getFamilias({ token, params })
        .then((response) => JSON.parse(response.body))
        .then((body) => {
            const opcoesFamilias = addDefaultSelectOptionFamilias(body);
            
            props.setState({
                opcoesFamilias,
                isSelectFamiliasMoveisDisabled: false
            });
        });
    };

    const addDefaultSelectOptionFamilias = (familias) => {
        familias.unshift({
            cd_familia: 0,
            nm_familia: "Selecione uma família",
        });
        return familias.sort((a, b) => (a.cd_familia > b.cd_familia) ? 1 : -1);
    };

    const getParamsLoadFamilias = ({ escolhaGrupo }) => {
        const { cd_grupo: cdGrupo, cd_div: cdDiv } = props.state.opcoesGrupos[escolhaGrupo];
        return { cdGrupo, cdDiv };
    };

    const handleChangeFamiliasMoveis = (event) => {
        props.setState({ escolhaFamilia: event.target.value });
    };

    const disableSelectFamilias = () => {
        props.setState({
            isSelectFamiliasMoveisDisabled: true,
        });
    };

    return {
        loadMoveis,
        handlerLoadSearchFilterTagMoveis,
        handlerSelectCheckboxMoveis,
        handlerClickCheckboxMoveis,
        handlerClearCheckboxMoveis,
        handlerChangeSearchFilterTagMoveis,
        handlerClearFilterTagMoveis,
        handlerChangeStatusMoveis,
        handlerChangeSituacoesMoveis,
        handlerCleanFiltersMoveis,
        handlerAplicarFiltersMoveis,
        handlerCheckboxAllMoveis,
        handlerChangeSearchFieldMoveis,
        handlerChangeSearchFieldExternalMoveis,
        handlerClickSearchFieldExternalMoveis,
        onChangePageMoveis,
        onClickViewModalMoveis,
        onChangeFileMoveis,
        handleChangeFamiliasMoveis,
        handleChangeGruposMoveis,
        disableSelectFamilias,
    };
};